module.exports = __webpack_public_path__ + "assets/images/project/menu/south-africa-thumb.jpg?v=e4ecfef8";